import React from 'react';
import { IconProps } from '../types';
const MinecraftRawCopper: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="2" width="1" height="1" fill="rgba(42, 84, 71, 255)" />
<rect x="4" y="2" width="1" height="1" fill="rgba(42, 84, 71, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(42, 84, 71, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(42, 84, 71, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="2" y="3" width="1" height="1" fill="rgba(42, 84, 71, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(77, 141, 121, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(58, 116, 99, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(58, 116, 99, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(42, 84, 71, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(42, 84, 71, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(42, 84, 71, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(148, 109, 61, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(233, 122, 82, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(252, 153, 130, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(252, 153, 130, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(201, 94, 53, 255)" />
<rect x="14" y="3" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="1" y="4" width="1" height="1" fill="rgba(42, 84, 71, 255)" />
<rect x="2" y="4" width="1" height="1" fill="rgba(79, 186, 152, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(79, 186, 152, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(77, 141, 121, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(79, 186, 152, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(58, 116, 99, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(77, 141, 121, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(148, 109, 61, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(233, 122, 82, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(252, 153, 130, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(254, 195, 182, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(252, 153, 130, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(233, 122, 82, 255)" />
<rect x="14" y="4" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="1" y="5" width="1" height="1" fill="rgba(42, 84, 71, 255)" />
<rect x="2" y="5" width="1" height="1" fill="rgba(132, 226, 197, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(201, 250, 236, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(132, 226, 197, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(79, 186, 152, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(79, 186, 152, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(148, 109, 61, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(148, 109, 61, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(201, 94, 53, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(201, 94, 53, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(233, 122, 82, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(201, 94, 53, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="0" y="6" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="1" y="6" width="1" height="1" fill="rgba(58, 116, 99, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(148, 109, 61, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(79, 186, 152, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(77, 141, 121, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(58, 116, 99, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(58, 116, 99, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(148, 109, 61, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(201, 94, 53, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="0" y="7" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="1" y="7" width="1" height="1" fill="rgba(252, 153, 130, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(233, 122, 82, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(77, 141, 121, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(148, 109, 61, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(58, 116, 99, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(148, 109, 61, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="0" y="8" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="1" y="8" width="1" height="1" fill="rgba(252, 153, 130, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(252, 153, 130, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(233, 122, 82, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(201, 94, 53, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(148, 109, 61, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(201, 94, 53, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="14" y="8" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="0" y="9" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="1" y="9" width="1" height="1" fill="rgba(233, 122, 82, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(252, 153, 130, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(201, 94, 53, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(233, 122, 82, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(201, 94, 53, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(252, 153, 130, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(201, 94, 53, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(233, 122, 82, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="14" y="9" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="15" y="9" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="1" y="10" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(233, 122, 82, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(201, 94, 53, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(201, 94, 53, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(252, 153, 130, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(254, 195, 182, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(233, 122, 82, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(201, 94, 53, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="14" y="10" width="1" height="1" fill="rgba(99, 91, 64, 255)" />
<rect x="15" y="10" width="1" height="1" fill="rgba(36, 59, 52, 255)" />
<rect x="1" y="11" width="1" height="1" fill="rgba(36, 59, 52, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(99, 91, 64, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(233, 122, 82, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(252, 153, 130, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(252, 153, 130, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(99, 91, 64, 255)" />
<rect x="14" y="11" width="1" height="1" fill="rgba(58, 116, 99, 255)" />
<rect x="15" y="11" width="1" height="1" fill="rgba(36, 59, 52, 255)" />
<rect x="1" y="12" width="1" height="1" fill="rgba(36, 59, 52, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(77, 141, 121, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(58, 116, 99, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(99, 91, 64, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(201, 94, 53, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(201, 94, 53, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(165, 73, 38, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="13" y="12" width="1" height="1" fill="rgba(58, 116, 99, 255)" />
<rect x="14" y="12" width="1" height="1" fill="rgba(58, 116, 99, 255)" />
<rect x="15" y="12" width="1" height="1" fill="rgba(36, 59, 52, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(36, 59, 52, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(36, 59, 52, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(36, 59, 52, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(201, 94, 53, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(136, 63, 38, 255)" />
<rect x="13" y="13" width="1" height="1" fill="rgba(36, 59, 52, 255)" />
<rect x="14" y="13" width="1" height="1" fill="rgba(36, 59, 52, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(36, 59, 52, 255)" />
<rect x="11" y="14" width="1" height="1" fill="rgba(36, 59, 52, 255)" />
<rect x="12" y="14" width="1" height="1" fill="rgba(36, 59, 52, 255)" />
</svg>);
export default MinecraftRawCopper;